export default __webpack_public_path__ + "static/media/game.e2fa4a43.png";